module.exports = __webpack_public_path__ + "static/img/funny_20.692af169.jpg";